

<div class="category-component-container page-root-container">
    <div class="page-header">
        <div class="page-title">
            <img class="icon" src="assets/images/menu/svg/stock-item.svg"><span class="title">Item Classes</span>
        </div>
        <div class="page-actions">
            <button mat-button color="primary" class="btn-add"
                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
            <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                [disabled]="IsDownloading">
                <img class="download-icon"
                    [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                Export
            </button>
        </div>
    </div>

    <div class="data-container">
        <app-loader [show]="isLoading"></app-loader>

        <app-search-filter #searchFilter [pagingData]="pagingData" 
            [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter"
            (page)="onePageEvent($event)" (onApply)="onFilterApplied($event)" [hidePageSize]="true">
        </app-search-filter>

        <section tabindex="0" class="table-container">
            <table matSort mat-table [dataSource]="dataSource">
                <!-- <ng-container matColumnDef="item">
                    <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                        class="item-header">#</th>
                    <td mat-cell *matCellDef="let itemClass; let i = index" class="item-column">{{
                        (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                </ng-container>  -->

                <ng-container matColumnDef="code">
                    <th mat-sort-header="ic.code" mat-header-cell style="width: 80px;"
                        *matHeaderCellDef (click)="sortData($event)">Code</th>
                    <td mat-cell *matCellDef="let itemClass" style="width: 80px;"> {{itemClass.code}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-sort-header="ic.name" mat-header-cell
                        *matHeaderCellDef (click)="sortData($event)"> Name </th>
                    <td mat-cell *matCellDef="let itemClass"> {{itemClass.name}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-sort-header="ic.description" mat-header-cell
                        *matHeaderCellDef (click)="sortData($event)"> Alternative Name </th>
                    <td mat-cell *matCellDef="let itemClass"> {{itemClass.description}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="super_class_id">
                    <th mat-sort-header="ic.super_class_id" mat-header-cell
                        *matHeaderCellDef (click)="sortData($event)"> Super Class </th>
                    <td mat-cell *matCellDef="let itemClass"> {{itemClass.superClassName}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="department_id">
                    <th mat-sort-header="ic.department_id" mat-header-cell
                        *matHeaderCellDef (click)="sortData($event)"> Department </th>
                    <td mat-cell *matCellDef="let itemClass"> {{itemClass.department}}
                    </td>
                </ng-container>
          
                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell class="row-menu-btn" style="width:50px"
                        *matCellDef="let rowItem">
                        <a mat-icon-button class="row-menu-btn"
                            [matMenuTriggerFor]="rowMenu" (click)="$event.stopPropagation();">
                            <mat-icon>more_vert</mat-icon>
                        </a>
                        <mat-menu #rowMenu>
                            <button mat-menu-item
                                (click)="onDelete(rowItem)">Delete</button>
                            <button mat-menu-item
                                (click)="onEdit(rowItem)">Edit</button>
                        </mat-menu>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                </tr>
                <tr mat-row class="table-element-row"
                    *matRowDef="let itemClass; columns: displayedColumns;"
                    (click)="onRowSelected(itemClass)"
                    (dblclick)="onEdit(itemClass)"
                    [ngClass]=" {'row-selected' : itemClass.id===selectedItem?.id}">
                </tr>
            </table>
        </section>

        @if(pagingData.length<=0){ 
            <div class="no-data-container">
                <img src="assets/images/no-data.png">
                <span class="no-data-info">No data found. Please remove or redefine the filters if any.</span>
            </div>
        }
    </div>
</div>